import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncComponentLoading = ({
  minHeight,
  LoadingIndicator = /*#__PURE__*/_jsx(LoadingSpinner, {
    "data-test-id": "async-component-loading",
    grow: true,
    minHeight: minHeight
  })
}) => {
  return LoadingIndicator;
};
AsyncComponentLoading.displayName = 'AsyncComponentLoading';
export default AsyncComponentLoading;